export const getProducerWinesPageLink = ({ producerId }) => {
  return `/#/wine-producer/${producerId}/wines`
}

export const getWineTastingsLink = ({ producerId, wineId }) => {
  return `/#/wine-producer/${producerId}/wines/${wineId}/tastings`
}
